import { useId } from "react";

/** Props that discourage password-manager / browser autofill on sensitive fields. */
export function passwordFieldProps(nameHint: string) {
  return {
    autoComplete: "new-password" as const,
    autoCorrect: "off" as const,
    autoCapitalize: "off" as const,
    spellCheck: false as const,
    "data-hm-nofill": "1",
    "data-lpignore": "true",
    "data-1p-ignore": "true",
    "data-bwignore": "true",
    "data-form-type": "other",
    name: nameHint,
  };
}

/** Props for search/filter text fields — marked for autofill wipe if untouched. */
export function useFilterFieldProps(key: string) {
  const ns = useId().replace(/:/g, "");
  return {
    autoComplete: "off" as const,
    autoCorrect: "off" as const,
    autoCapitalize: "off" as const,
    spellCheck: false as const,
    "data-hm-filter": key,
    "data-lpignore": "true",
    "data-1p-ignore": "true",
    "data-form-type": "other",
    name: `filter-${key}-${ns}`,
  };
}
